import { getQueue, logWorkspace, serviceState } from '../..';
import getQueues from '../../getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';

async function handleQueueSessionJoin(event: Telecom.QueueSessionJoinedEvent) {
  const queue = getQueue(event.queueId);

  logWorkspace('service:queue:session_join:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  queue.status.abandonedSessions = event.stats.abandonedSessions;
  queue.status.activeSessionCount = event.stats.activeSessions;
  queue.status.averageWait = event.stats.averageWaitMs;
  queue.status.longestWait = event.stats.longestWaitMs;
  queue.status.missedSessions = event.stats.missedSessions;
  queue.status.recipientCount = event.stats.agents;
  queue.status.totalSessions = event.stats.totalSessions;

  // save the estimated wait time for 'delivered' event
  // suggested by Kazoo to do this only in 'delivered'
  // and 'join' events. this value is recalculated on these events
  queue.status.estimatedWait = event.stats.estimatedWaitMs;

  queue.sessions = [
    ...queue.sessions,
    {
      id: event.conversationId,
      position: event.joinedAtPosition,
      name: event.source.displayName || event.source.address,
      enteredAt: new Date(event.joinedAtTime),
    },
  ];

  return;
}

export default handleQueueSessionJoin;
